import { render } from "./NavigationView.vue?vue&type=template&id=ebd6d292"
import script from "./NavigationView.vue?vue&type=script&lang=js"
export * from "./NavigationView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/PEP/PEP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__